import React from 'react'
import pluralize from 'pluralize'
import '../assets/css/components/character-overview-card.css'
import backgroundImage from '../assets/img/Player_Character_Summary.png'

const CharacterOverviewCard = props => {
  const { profile, completedQuestCount } = props

  const getDisplayName = () => {
    if(profile.last_name) {
      return profile.first_name + ' ' + profile.last_name
    } else {
      return profile.first_name
    }
  }


  return(
    <div className="col-md-6">
      <div className="row">
        <div className="col-md-12 m-b-10">
          <div className="ar-3-2 widget-1-wrapper">

            <div style={{'backgroundImage':'url('+backgroundImage+')'}} className="character-overview-card widget-1 panel no-border bg-complete no-margin widget-loader-circle-lg">
              <div className="panel-heading top-right ">
                <div className="panel-controls">
                  <ul>
                  </ul>
                </div>
              </div>
              <div className="panel-body">
                <div className="footer pull-bottom bottom-left bottom-right ">
                  <span className="label font-montserrat fs-11">{ getDisplayName() }</span>
                  <br/>
                  <h2 className="text-white">{ profile.character_name || 'No character has been created yet' }</h2>
                  <div className="stock-rates m-t-15">
                    <div className="company col-xs-12">
                      {/*<div className="welcome-card-item">
                        <p className="font-montserrat no-margin fs-16 text-primary">
                          <i className="fa fa-caret-up all-caps"></i>
                        </p>
                        <p className="bold text-white no-margin fs-11 font-montserrat lh-normal">PLAYED TODAY</p>
                      </div>*/}
                      <div className="welcome-card-item">
                        <p className="font-montserrat no-margin fs-16 text-success">
                          { pluralize('QUESTS', (completedQuestCount || 0), true) }
                        </p>
                        <p className="bold text-white no-margin fs-11 font-montserrat lh-normal">COMPLETED TODAY</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default CharacterOverviewCard
